module.exports = __webpack_public_path__ + "static/img/logo.a0d715e.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 7Ogj
// module chunks = 19